// extracted by mini-css-extract-plugin
module.exports = {"Box":"box_Box__LxIr9","SubBox":"box_SubBox__24Cwy"};